export default __webpack_public_path__ + "static/media/selo-gptw 2024.d8846266.png";